import type { ComponentRendering, RouteData } from '@sitecore-content-sdk/nextjs';
import clsx from 'clsx';

import type { Navigation } from '@generated/Navigation/Header.model';
import { PlaceholderWrapper } from 'components/helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { findComponent } from 'lib/utils/object-utils';
import { getHeaderLanguageLinks, shouldShowHeaderLanguageRow } from '../Header.utils';
import styles from './HeaderPlaceholder.module.scss';

type HeaderRendering = ComponentRendering & Navigation.Header.Header;

export interface HeaderPlaceholderProps {
  route: RouteData;
}

export const HeaderPlaceholder = ({ route }: HeaderPlaceholderProps) => {
  const headerRendering = findComponent<HeaderRendering>(route, 'Header')[0];
  const languageLinks = getHeaderLanguageLinks(
    headerRendering?.fields?.supportedLanguages as Navigation.Header.Language[] | undefined
  );
  const hasLanguageRow = shouldShowHeaderLanguageRow(
    headerRendering?.fields?.hideLanguageToggle?.value,
    languageLinks
  );

  return (
    <div
      className={clsx(styles.headerPlaceholder, {
        [styles.hasLanguageRow]: hasLanguageRow,
      })}
    >
      <PlaceholderWrapper helpTextHideIf={true} name="headless-header" rendering={route} />
    </div>
  );
};
